import L from 'leaflet';

/**
 * Create a custom marker icon
 * @param {boolean} isActive - Whether the marker is active
 * @param {boolean} isSelected - Whether the marker is selected
 * @returns {L.DivIcon} A custom Leaflet icon
 */
const createCustomIcon = (isActive, isSelected) => {
  return L.divIcon({
    className: 'custom-icon',
    html: `<div style="
      width: ${isSelected ? '24px' : '20px'};
      height: ${isSelected ? '24px' : '20px'};
      border-radius: 50%;
      background-color: ${isActive ? '#22c55e' : '#0066B1'};
      border: 3px solid ${isSelected ? '#000' : '#fff'};
      box-shadow: 0 0 8px rgba(0,0,0,0.3);
    "></div>`,
    iconSize: [isSelected ? 24 : 20, isSelected ? 24 : 20],
    iconAnchor: [isSelected ? 12 : 10, isSelected ? 12 : 10],
  });
};

export default createCustomIcon;